import { Avatar, Box, Button, Flex, Image, Text } from "@chakra-ui/react";
import { customDateFormat, customDateTimeFormat } from "../../utils/utils";
import iconApproved from "../../assets/images/receiveSalary/check-circle.svg";
import iconRejected from "../../assets/images/contract/x-circle.svg";

export const formatTableValue = (value, key, submit, id) => {
  switch (key) {
    case "requestDate":
      return <Text>{ customDateTimeFormat(value)}</Text>;
    case "startDate":
      return <Text>{ customDateFormat(value)}</Text>;
    case "approvedDate":
        return <Text>{ customDateTimeFormat(value)}</Text>;
    case "contact":
      const infos = value?.split("-") || [];
      return (
        <Flex direction={"column"} justifyContent={"left"}>
          {infos?.length &&
            infos?.map((item, index) => <Text key={index}>{item}</Text>)}
        </Flex>
      );
    case "bankInfo":
      const bankInfo = value?.split("-") || [];
      return (
        <Flex direction={"column"} justifyContent={"left"}>
          {bankInfo?.length &&
            bankInfo?.map((item, index) => <Text key={index}>{item}</Text>)}
        </Flex>
      );
    case "identificationNumberInfo":
      const identificationNumberInfo = value?.split("-") || [];
      return (
        <Flex direction={"column"} justifyContent={"left"}>
          {identificationNumberInfo?.length &&
            identificationNumberInfo?.map((item, index) => (
              <Text key={index}>{item}</Text>
            ))}
        </Flex>
      );
    case "avatar":
      return <Avatar src={value} />;
    case "status":
      let content;
      if (value === 1) {
        content = (
          <Flex gap={"8px"} w={"max-content"}>
            <Button
              bg={"var(--linear-gradient-employee)"}
              color={"var(--color-main)"}
              fontSize={"12px"}
              lineHeight={"17px"}
              fontWeight={"600"}
              _hover={{
                filter: "brightness(90%)",
              }}
              onClick={() => submit(2, id)}
              h={"28px"}
              minH={"28px"}
              w={"90px"}
            >
              Duyệt
            </Button>
            <Button
              bg={"var(--color-main)"}
              color={"var(--color-option-employee-hover)"}
              border={"1px solid var(--color-option-employee-hover)"}
              fontSize={"12px"}
              lineHeight={"17px"}
              fontWeight={"600"}
              _hover={{
                filter: "brightness(90%)",
              }}
              onClick={() => submit(3, id)}
              h={"28px"}
              minH={"28px"}
              w={"90px"}
            >
              Ko duyệt
            </Button>
          </Flex>
        );
      } else if (value === 2) {
        content = (
          <Flex gap={"8px"} w={"max-content"}>
            <Image src={iconApproved} />
            <Text color={"var(--color-status-employ)"}>Đã được duyệt</Text>
          </Flex>
        );
      } else {
        content = (
          <Flex gap={"8px"} w={"max-content"}>
            <Image src={iconRejected} />
            <Text color={"var(--text-red-employee)"}>Không được phê duyệt</Text>
          </Flex>
        );
      }

      return (
        <Flex gap={"8px"} w={"full"}>
          <Box w={"full"}>{content}</Box>
        </Flex>
      );
    case "employee":
        return (
            <Box>
                <Text 
                    fontSize={"14px"}
                    lineHeight={"19.6px"}
                    fontWeight={"500"}
                    color={"var(--color-info-employee)"}
                >
                    {value.fullName}
                </Text>
                <Text 
                    fontSize={"12px"}
                    lineHeight={"16.8px"}
                    fontWeight={"400"}
                    color={"var(--color-label-employee)"}
                >
                    {value.jobPosition}
                </Text>
            </Box>
        )
        case "approved":
          return (
              <Box>
                  <Text 
                      fontSize={"14px"}
                      lineHeight={"19.6px"}
                      fontWeight={"500"}
                      color={"var(--color-info-employee)"}
                  >
                      {value.fullName}
                  </Text>
                  <Text 
                      fontSize={"12px"}
                      lineHeight={"16.8px"}
                      fontWeight={"400"}
                      color={"var(--color-label-employee)"}
                  >
                      {value.jobPosition}
                  </Text>
              </Box>
          )
    default:
      return <Text>{value}</Text>;
  }
};